export const COMMON_FACULTIES = [
  "Tıp Fakültesi",
  "Diş Hekimliği Fakültesi",
  "Eczacılık Fakültesi",
  "Sağlık Bilimleri Fakültesi",
  "Hemşirelik Fakültesi",
  "Veteriner Fakültesi",
  "Mühendislik Fakültesi",
  "Mimarlık Fakültesi",
  "Mühendislik ve Doğa Bilimleri Fakültesi",
  "Mimarlık ve Tasarım Fakültesi",
  "Güzel Sanatlar Fakültesi",
  "Sanat ve Tasarım Fakültesi",
  "Fen Fakültesi",
  "Edebiyat Fakültesi",
  "Fen-Edebiyat Fakültesi",
  "İnsan ve Toplum Bilimleri Fakültesi",
  "Dil ve Tarih-Coğrafya Fakültesi",
  "Eğitim Fakültesi",
  "İletişim Fakültesi",
  "İlahiyat Fakültesi",
  "İslami İlimler Fakültesi",
  "Hukuk Fakültesi",
  "İktisadi ve İdari Bilimler Fakültesi",
  "Siyasal Bilgiler Fakültesi",
  "İşletme Fakültesi",
  "İktisat Fakültesi",
  "Spor Bilimleri Fakültesi",
  "Turizm Fakültesi",
  "Ziraat Fakültesi",
  "Orman Fakültesi",
  "Su Ürünleri Fakültesi",
  "Deniz Bilimleri Fakültesi",
  "Denizcilik Fakültesi",
  "Teknoloji Fakültesi",
  "Uygulamalı Bilimler Fakültesi",
  "Havacılık ve Uzay Bilimleri Fakültesi",
  "Açık ve Uzaktan Eğitim Fakültesi",
  "Ulaştırma Ve Lojistik Fakültesi",
  "Bilgisayar ve Bilişim Teknolojileri Fakültesi",
];

const CUSTOM_MAPPINGS: Record<string, string> = {
  tip: "Tıp Fakültesi",
  tıp: "Tıp Fakültesi",
  hukuk: "Hukuk Fakültesi",
  iibf: "İktisadi ve İdari Bilimler Fakültesi",
  sbf: "Siyasal Bilgiler Fakültesi",
  auzeff: "Açık ve Uzaktan Eğitim Fakültesi",
  dtcf: "Dil ve Tarih-Coğrafya Fakültesi",
  besyo: "Spor Bilimleri Fakültesi",
  mezun: "Mezun",
  "beden eğitimi ve spor yüksekokulu": "Spor Bilimleri Fakültesi",
  "ulaştırma ve lojistik": "Ulaştırma Ve Lojistik Fakültesi",
  isletme: "İşletme Fakültesi",
  işletme: "İşletme Fakültesi",
  iktisat: "İktisat Fakültesi",
  muhendislik: "Mühendislik Fakültesi",
  mühendislik: "Mühendislik Fakültesi",
  mimarlik: "Mimarlık Fakültesi",
  mimarlık: "Mimarlık Fakültesi",
  egitim: "Eğitim Fakültesi",
  eğitim: "Eğitim Fakültesi",
  iletisim: "İletişim Fakültesi",
  iletişim: "İletişim Fakültesi",
  ilahiyat: "İlahiyat Fakültesi",
  ziraat: "Ziraat Fakültesi",
  eczacilik: "Eczacılık Fakültesi",
  eczacılık: "Eczacılık Fakültesi",
  veteriner: "Veteriner Fakültesi",
  "dis hekimligi": "Diş Hekimliği Fakültesi",
  "diş hekimliği": "Diş Hekimliği Fakültesi",
  "fen edebiyat": "Fen-Edebiyat Fakültesi",
  "fen-edebiyat": "Fen-Edebiyat Fakültesi",
  "insan ve toplum bilimleri": "İnsan ve Toplum Bilimleri Fakültesi",
  "su ürünleri": "Su Ürünleri Fakültesi",
  "su urunleri": "Su Ürünleri Fakültesi",
  "spor bilimleri": "Spor Bilimleri Fakültesi",
  "sağlık bilimleri": "Sağlık Bilimleri Fakültesi",
  "saglik bilimleri": "Sağlık Bilimleri Fakültesi",
  "güzel sanatlar": "Güzel Sanatlar Fakültesi",
  "guzel sanatlar": "Güzel Sanatlar Fakültesi",
  "uygulamalı bilimler": "Uygulamalı Bilimler Fakültesi",
  "uygulamali bilimler": "Uygulamalı Bilimler Fakültesi",
  denizcilik: "Denizcilik Fakültesi",
  havacilik: "Havacılık ve Uzay Bilimleri Fakültesi",
  havacılık: "Havacılık ve Uzay Bilimleri Fakültesi",
  teknoloji: "Teknoloji Fakültesi",
  bbtf: "Bilgisayar ve Bilişim Teknolojileri Fakültesi",
  "bilgisayar ve bilişim teknolojileri":
    "Bilgisayar ve Bilişim Teknolojileri Fakültesi",
  "bilgisayar ve bilisim teknolojileri":
    "Bilgisayar ve Bilişim Teknolojileri Fakültesi",
};

export function normalizeFaculty(input: string): string {
  const trimmed = input.trim();
  if (!trimmed) return "";

  // Normalize Turkish characters for robust comparison
  const normalizeForSearch = (str: string) =>
    str
      .toLocaleLowerCase("tr-TR")
      .replace(/ı/g, "i")
      .replace(/ğ/g, "g")
      .replace(/ü/g, "u")
      .replace(/ş/g, "s")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c");

  const searchInput = normalizeForSearch(trimmed);

  // 1. Check custom mappings (with normalized keys)
  for (const [key, value] of Object.entries(CUSTOM_MAPPINGS)) {
    if (normalizeForSearch(key) === searchInput) {
      return value;
    }
  }

  // 2. Exact match in COMMON_FACULTIES (normalized)
  const exactMatch = COMMON_FACULTIES.find(
    (f) => normalizeForSearch(f) === searchInput,
  );
  if (exactMatch) return exactMatch;

  // 3. Keyword contains match (e.g. "Tıp" matches "Tıp Fakültesi")
  if (!searchInput.includes("fakultesi")) {
    const match = COMMON_FACULTIES.find((f) => {
      const normalizedF = normalizeForSearch(f);
      // Ensure it's a whole word match or starts with it
      return (
        normalizedF.startsWith(searchInput) ||
        normalizedF.includes(`${searchInput} `)
      );
    });
    if (match) return match;
  }

  // 4. Fallback: Standardize casing for new/unknown faculties
  return trimmed
    .split(" ")
    .map((word) => {
      if (!word) return "";
      return (
        word.charAt(0).toLocaleUpperCase("tr-TR") +
        word.slice(1).toLocaleLowerCase("tr-TR")
      );
    })
    .join(" ");
}
